export const dataLibN = [{
  word: 'né',
  partOfSpeech: 'N',
  definition: ['nose'],
  egSentenceKw: 'I ni on gwo né.',
  egSentenceEn: 'He has a big nose.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. nez]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nich',
  partOfSpeech: 'N',
  definition: ['nest'],
  egSentenceKw: 'Jibyé-a fè on nich asou pyé mango-a.',
  egSentenceEn: 'The bird made a nest in the mango tree.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. niche]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nwè',
  partOfSpeech: 'ADJ',
  definition: ['black'],
  egSentenceKw: 'I ka pòté soulyé nwè.',
  egSentenceEn: 'He\'s wearing black shoes.',
  synonym: [null],
  antonym: ['blan'],
  etymology: '[< Fr. noir]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ni',
  partOfSpeech: 'V',
  definition: ['to have'],
  egSentenceKw: 'Mwen ni twa dòla an pòch mwen.',
  egSentenceEn: 'I have three dollars in my pocket.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nou',
  partOfSpeech: 'PRO',
  definition: ['we', 'us', 'our'],
  egSentenceKw: 'Mwen ni twa dòla an pòch mwen.',
  egSentenceEn: 'I have three dollars in my pocket.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. nous]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nou',
  partOfSpeech: 'PRO',
  definition: ['new'],
  egSentenceKw: 'Sa sé on lwa nivo.',
  egSentenceEn: 'That is a new law',
  synonym: ['nèf'],
  antonym: ['vyé'],
  etymology: '[< Fr. nouveau]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nèf',
  partOfSpeech: 'PRO',
  definition: ['new'],
  egSentenceKw: 'Motoka\'y té nèf lè i kwazé\'y.',
  egSentenceEn: 'His car was new when he wrecked it.',
  synonym: ['nivo'],
  antonym: ['vyé'],
  etymology: '[< Fr. neuf]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nonm',
  partOfSpeech: 'N',
  definition: ['man'],
  egSentenceKw: 'Nonm-lan ka twavay wèd.',
  egSentenceEn: 'The man works hard.',
  synonym: ['misyé'],
  antonym: [null],
  etymology: '[< Fr. un homme]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nonm',
  partOfSpeech: 'ADJ',
  definition: ['mannish; when a boy rudely acts older than he really is'],
  egSentenceKw: 'Tibway sala twò nonm.',
  egSentenceEn: 'That boy is too mannish.',
  synonym: ['misyé'],
  antonym: [null],
  etymology: '[< Fr. un homme]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nòlaj',
  partOfSpeech: 'N',
  definition: ['knowledge'],
  egSentenceKw: 'Misyé sala ni an chay nòlaj konsèné Bib-la.',
  egSentenceEn: 'That man has a lot of knowledge about the Bible.',
  synonym: [null],
  antonym: ['inyowans'],
  etymology: '[< Eng. knowledge]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nòs',
  partOfSpeech: 'N',
  definition: ['nurse'],
  egSentenceKw: 'Nòs-la ka otjipé fwè mwen.',
  egSentenceEn: 'The nurse takes care of my brother.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. nurse]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ni',
  partOfSpeech: 'V',
  definition: ['to be'],
  egSentenceKw: 'Nivé mwen ni ven lanné.',
  egSentenceEn: 'My nephew is twenty years old.',
  synonym: ['oblijé', 'sé fo', 'sé pou'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['dwé'],
}, {
  word: 'ni',
  partOfSpeech: 'ADJ',
  definition: ['bare'],
  egSentenceKw: 'Ti manmay-la ka maché ni pyé an labou-a.',
  egSentenceEn: 'The child was walking barefoot in the mud.',
  synonym: ['pyé ni'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['dwé'],
},
];
